import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const KeyActivation = ({ operatorid, ownerid, path }) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator } = React.useContext(AppContext)

  return (
    <cl-user-key
      mountPath={`/operators/${operatorid}/${path}/${ownerid}`}
      apiUrl={`https://access-control.${env()}.credlock.net/api`}
      operatorid={operatorid}
      token={token}
      ownerid={ownerid}
      operatorName={operator.name}
    />
  )
}

export default KeyActivation
